export const Q25_UNIQUE_PAYMENT_PO_ID = 'Q25UNIQUEPAYMENT001'
export const Q25_FINANCING_PO_ID = 'Q25EXTENSION001'
export const Q25_NO_ACTION_PO_ID = 'Q25WITHOUTACTIONAAA001'
